import { HubSplitSectionContentType } from 'utils/gloo-types';
import Button from 'components/atoms/Button';
import Typography from 'components/atoms/Typography';
import { SplitWidthSection } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/types';

export default function SplitSectionOptions({
  splitWidthSectionState,
  setSplitWidthSectionState,
}: {
  splitWidthSectionState: SplitWidthSection;
  setSplitWidthSectionState: (nextState: SplitWidthSection) => void;
}) {
  return (
    <div className="flex content-between m-auto max-w-[500px] mb-[19px]">
      <div className="flex flex-col w-full mr-2">
        <Typography className="text-center mb-2" variant="h4">
          Left
        </Typography>
        <Button
          className="mb-3 justify-center font-normal"
          type={splitWidthSectionState.a === HubSplitSectionContentType.IMAGE ? 'gray-toggle' : 'tertiary'}
          onClick={() => {
            setSplitWidthSectionState({
              ...splitWidthSectionState,
              a: HubSplitSectionContentType.IMAGE,
            });
          }}
          dataDurableId="SplitWidthSectionLeftMediaButton"
          text="Media"
        />
        <Button
          className="justify-center font-normal"
          type={splitWidthSectionState.a === HubSplitSectionContentType.TEXT ? 'gray-toggle' : 'tertiary'}
          onClick={() => {
            setSplitWidthSectionState({
              ...splitWidthSectionState,
              a: HubSplitSectionContentType.TEXT,
            });
          }}
          dataDurableId="SplitWidthSectionLeftTextButton"
          text="Text"
        />
      </div>
      <div className="flex flex-col w-full ml-2">
        <Typography className="text-center mb-2" variant="h4">
          Right
        </Typography>
        <Button
          className="justify-center mb-3 font-normal"
          type={splitWidthSectionState.b === HubSplitSectionContentType.IMAGE ? 'gray-toggle' : 'tertiary'}
          onClick={() => {
            setSplitWidthSectionState({
              ...splitWidthSectionState,
              b: HubSplitSectionContentType.IMAGE,
            });
          }}
          dataDurableId="SplitWidthSectionRightMediaButton"
          text="Media"
        />
        <Button
          className="justify-center font-normal"
          type={splitWidthSectionState.b === HubSplitSectionContentType.TEXT ? 'gray-toggle' : 'tertiary'}
          onClick={() => {
            setSplitWidthSectionState({
              ...splitWidthSectionState,
              b: HubSplitSectionContentType.TEXT,
            });
          }}
          dataDurableId="SplitWidthSectionRightTextButton"
          text="Text"
        />
      </div>
    </div>
  );
}
